import React from 'react';

import { Icon } from "components/Icon";


import { Input, InputGroup } from "rsuite";

const InputSearch = ({onChange, placeholder,...props}) => (
    <InputGroup >
        <Input onChange={onChange} placeholder={placeholder} {...props}/>
        <InputGroup.Addon>
            <Icon icon="search" />
        </InputGroup.Addon>
    </InputGroup>
)


export default InputSearch;